import React from 'react';
import * as S from './SidebarIcon.styles';

interface SidebarIconProps {
  icon: string | React.ReactNode;
  label: string;
  expanded: boolean;
  active?: boolean;
  onClick?: () => void;
}

export const SidebarIcon: React.FC<SidebarIconProps> = ({
  icon,
  label,
  expanded,
  active = false,
  onClick,
}) => {
  return (
    <S.SidebarIconContainer
      $expanded={expanded}
      $active={active}
      onClick={onClick}
      title={label}
    >
      <S.SidebarIconIcon $expanded={expanded} $active={active}>
        {typeof icon === 'string' ? icon : icon}
      </S.SidebarIconIcon>
      <S.SidebarIconLabel $expanded={expanded} $active={active}>
        {label}
      </S.SidebarIconLabel>
    </S.SidebarIconContainer>
  );
};
